module.exports = "//static.hsappstatic.net/LoginUI/static-1.15098/img/warning.svg"